// Text To Speech
import {TtsPlayerVoice} from "~/libs/interfaces/TtsPlayerVoice"

export interface TtsIframeUrlParams {
  id: string
  voice?: TtsPlayerVoice,
  autoplay?: boolean,
  startTime?: number
  site?: string
}

export const useTts = () => {
  const getIframeUrl = (
    payload: TtsIframeUrlParams
  ):string|undefined => {
    const runtimeConfig = useRuntimeConfig()
    const url = runtimeConfig.public.tts?.iframeUrl || ''
    const site = runtimeConfig.public.tts?.site || 'uni-fe'
    if (!payload.voice) {
      payload.voice = TtsPlayerVoice.MALE
    }
    if (typeof payload.autoplay === 'undefined') {
      payload.autoplay = runtimeConfig.public.tts?.autoplay || false
    }
    if (!payload.startTime) {
      // start from beginning
      payload.startTime = 0
    }

    return url
      .replace(/%ID%/g, useShortItemId(payload.id) || '')
      .replace(/%VOICE%/g, payload.voice)
      .replace(/%AUTOPLAY%/g, payload.autoplay ? '1' : '0')
      .replace(/%START_TIME%/g, String(payload.startTime))
      .replace(/%SITE%/g, String(site))
  }

  const isEnabled = ():boolean => {
    const runtimeConfig = useRuntimeConfig()
    return runtimeConfig.public.tts?.enabled || false
  }

  return {
    isEnabled,
    getIframeUrl
  }
}
